<template>
  <div>
    <Modal title="Fournisseur Hors Référencement" :open="open" @close="$emit('close')">
      <form @submit="submit">
        <div v-if="$store.state.self.isAdmin" class="form-group">
          Accès
          <div class="form-check grp-list">
            <label v-for="grp of Groupes" :key="grp.Guid">
              <input type="checkbox" v-model="GroupeGuidList" :value="grp.Guid" />
              {{grp.Name}}
            </label>
          </div>
        </div>
        <div class="form-group">
          <label>
            Nom*
            <input class="form-control" type="text" v-model="Nom" />
          </label>
        </div>
        <div class="form-group">
          <label>
            Famille
            <select v-model="IdFamille" class="form-control" @change="IdSousFamille=-1">
              <option :value="-1">Aucune</option>
              <option v-for="fam of familles" :key="fam.Id" :value="fam.Id">{{fam.Libelle}}</option>
            </select>
          </label>
        </div>
        <div class="form-group">
          <label>
            Sous Famille
            <select v-model="IdSousFamille" class="form-control" @change="subFamilyChanged">
              <option :value="-1">Aucune</option>
              <option v-for="fam of activeSousFamilles" :key="fam.Id" :value="fam.Id">{{fam.Libelle}}</option>
            </select>
          </label>
        </div>
        <div class="form-group">
          <label>
            Ville
            <input class="form-control" type="text" v-model="Ville" />
          </label>
        </div>
        <div class="form-group">
          <label>
            Code Postal
            <input class="form-control" type="text" v-model="CodePostal" />
          </label>
        </div>
        <div class="form-group">
          <label>
            Siret
            <input class="form-control" type="text" v-model="Siret" />
          </label>
        </div>
        <div class="form-group">
          <label>
            Validé
            <br />
            <input class="form-check-input" type="checkbox" v-model="Valide" :disabled="!$store.state.self.isAdmin" />
          </label>
        </div>
        <div class="form-group text-center">
          <button class="btn btn-success w-50" type="submit" :disabled="!Nom">Valider</button>
        </div>
      </form>
    </Modal>
  </div>

</template>

<script>
  import Modal from "@/components/Modal"

  import { getAllMembersHierarchy } from "@/utils/member";
  import { updateFrsHR } from "@/utils/frsHR"

  export default {
    name: "CreateFrsHRModal",
    components: {
      Modal
    },
    props: {
      open: Boolean,
      pIdFrsHR: Number,
      pNom: String,
      pIdFamille: Number,
      pIdSousFamille: Number,
      pVille: String,
      pCodePostal: String,
      pSiret: String,
      pValide: Boolean,
      pGroupeGuidList: Array,
      familles: Array,
      sousFamilles: Array
    },
    data() {
      return {
        IdFrsHR: -1,
        Nom: "",
        IdFamille: -1,
        IdSousFamille: -1,
        Ville: "",
        CodePostal: "",
        Siret: "",
        GroupeGuidList: [],
        Valide: false,
        Groupes: []
      }
    },
    mounted() { // Si l'information est envoyée par les props, on remplace la valeur par défaut
      if (this.pIdFrsHR) this.IdFrsHR = this.pIdFrsHR
      if (this.pNom) this.Nom = this.pNom
      if (this.pIdFamille) this.IdFamille = this.pIdFamille
      if (this.pIdSousFamille) this.IdSousFamille = this.pIdSousFamille
      if (this.pVille) this.Ville = this.pVille
      if (this.pCodePostal) this.CodePostal = this.pCodePostal
      if (this.pSiret) this.Siret = this.pSiret
      if (this.pValide) this.Valide = this.pValide
      if (this.pGroupeGuidList) this.GroupeGuidList = this.pGroupeGuidList

      // Récupération des groupements
      if (this.$store.state.self.isAdmin) {
        getAllMembersHierarchy(1).then(res => {
          res.sort((a, b) => a.Name < b.Name ? -1 : 1);
          this.Groupes = res
        });
      }
    },
    computed: {
      activeSousFamilles() { // Récupère la liste des sous familles en fonction de la famille sélectionnée
        return this.sousFamilles.filter(sf => sf.IdParent == this.IdFamille || this.IdFamille == -1)
      }
    },
    methods: {
      subFamilyChanged(e) { // On met à jour la famille selon la sous-famille sélectionnée
        if (this.IdSousFamille != -1) { // Sauf si la sous famille est "aucune"
          const sousFamille = this.sousFamilles.find(el => el.Id == this.IdSousFamille)
          this.IdFamille = sousFamille.IdParent;
        }
      },
      submit(e) { // On créé ou on met à jour une frs hors référencement
        e.preventDefault();
        updateFrsHR(this.IdFrsHR, this.IdFamille, this.IdSousFamille, this.Valide, this.Nom, this.Ville, this.CodePostal, this.Siret, this.GroupeGuidList).then(() => this.$emit('submitted'))
      }
    }
  }
</script>

<style scoped>
  .form-group {
      margin-top: 18px;
  }

  .grp-list {
      margin-top: 18px;
      display: grid;
      grid-template-columns: repeat(auto-fill, 200px);
  }
</style>



// WEBPACK FOOTER //
// src/components/CreateFrsHRModal.vue